import { render, staticRenderFns } from "./CustomerProfileStatsSectionV2.vue?vue&type=template&id=0a3c2da4&"
import script from "./CustomerProfileStatsSectionV2.vue?vue&type=script&lang=js&"
export * from "./CustomerProfileStatsSectionV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
installComponents(component, {VAlert,VAvatar,VCard,VCardText})
